// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon--6hbUL","svg":"svg--33zZF"};